import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import styles from '../Assets/Styles/Components/BottomBar.module.css';

class BottomBar extends Component {
	constructor() {
		super();
		this.state = {
			showPhotographers: false,
			count: 300,
		};
	}

	componentDidUpdate(preProps) {
		if (this.props.checkout && this.props.checkout.checkout && this.props.checkout.checkout.total !== preProps.checkout.checkout.total) {
			this.animateValue(this.state.count, this.props.checkout.checkout.total, 500);
		}
	}

	showPhotographersPro = () => {
		this.setState({ showPhotographers: true });
		setTimeout(() => {
			this.setState({ showPhotographers: false });
		}, 2000);
	};

	animateValue = (start, end, duration) => {
		if (start === end) return;
		const range = start - end;
		let current = start;
		const step = start > end ? -1 : 1;
		const ifState = start > end ? (current >= end) : (current <= end);
		const stepTime = Math.abs(Math.floor(duration / range));
		setTimeout(() => {
			const timer = setInterval(() => {
				current += step;
				if (ifState) {
					this.setState({ count: current });
					if (current === end) {
						clearInterval(timer);
					}
				}
			}, stepTime);
		}, 100);
	}

	render() {
		const { checkout } = this.props;
		const { showPhotographers } = this.state;
		return (
			<div className={`${styles.bottomBar} ${checkout?.checkout?.avatars && checkout.checkout.total > 1 ? styles.show : ''}`}>
				<div className={`${styles.photographersContainer} ${this.state.showPhotographers ? styles.photographersContainerShow : ''}`}>
					{checkout?.checkout?.avatars && checkout.checkout.total >= 1 &&
						<div className={styles.imageContainer}>
							{
								checkout.checkout.avatars && checkout.checkout.avatars.map((item) => {
									return <img key={item} className={styles.logoShape} src={`https://kadro.co/${item.thumb}`} alt={item.thumb} />;
								})
							}
							<div className={styles.extra}><p>{checkout.checkout.total - 2} + نفر</p></div>
						</div>}
				</div>
				<div className={styles.bottomBarContainer}>
					<div className={styles.photographers} onClick={!showPhotographers && this.showPhotographersPro}>
						{
							this.state.loading ? <div className={styles.loader} /> : (
								<>
									<p><div className={styles.couter}>{this.state.count}</div> متخصص آماده رزرو با شرایط انتخابی شما</p>
									<i className={`fas fa-chevron-circle-up ${styles.up} ${this.state.showPhotographers ? styles.down : ''}`} />
								</>
							)
						}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		checkout: state.checkout,
		project: state.project,
	};
};
export default connect(mapStateToProps)(withRouter(BottomBar));
